import React from "react";

// Muestra los auxiliares nuevos y los que cambiaron datos de pago (nombre, rut, banco,
// tipo de cuenta, número de cuenta) respecto de la última nómina exportada. Modal propio
// (en vez de gdAlertify) porque la lista puede ser larga y gdAlertify no tiene scroll.
const NominaCambiosModal = ({ visible, onClose, resultado }) => {
    if (!visible || !resultado) return null;

    const { nuevos = [], cambios = [] } = resultado;

    return (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header bg-warning-subtle">
                        <h5 className="modal-title">
                            <i className="bi bi-exclamation-triangle-fill text-warning me-2"></i>
                            Revisar antes de pagar
                        </h5>
                        <button className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                        {nuevos.length > 0 && (
                            <div className="mb-4">
                                <h6 className="fw-bold">
                                    <i className="bi bi-person-plus me-2"></i>
                                    Nuevos en la nómina ({nuevos.length})
                                </h6>
                                <table className="table table-sm table-striped align-middle">
                                    <thead>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Rut</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {nuevos.map((n, idx) => (
                                            <tr key={`nuevo-${n.auxiliar_id}-${idx}`}>
                                                <td>{n.nombre}</td>
                                                <td>{n.rut || "sin rut"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {cambios.length > 0 && (
                            <div>
                                <h6 className="fw-bold">
                                    <i className="bi bi-arrow-left-right me-2"></i>
                                    Cambios de datos de pago ({cambios.length})
                                </h6>
                                <table className="table table-sm table-striped align-middle">
                                    <thead>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Rut</th>
                                            <th>Campo</th>
                                            <th>Antes</th>
                                            <th>Ahora</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cambios.map((c, idx) => (
                                            (c.diferencias || []).map((d, dIdx) => (
                                                <tr key={`cambio-${c.auxiliar_id}-${idx}-${dIdx}`}>
                                                    {dIdx === 0 && (
                                                        <>
                                                            <td rowSpan={c.diferencias.length}>{c.nombre}</td>
                                                            <td rowSpan={c.diferencias.length}>{c.rut || "sin rut"}</td>
                                                        </>
                                                    )}
                                                    <td>{d.campo}</td>
                                                    <td className="text-muted">{d.anterior || "-"}</td>
                                                    <td className="fw-bold">{d.nuevo || "-"}</td>
                                                </tr>
                                            ))
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NominaCambiosModal;
